export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      experience: "Experience",
      services: "Services",
      portfolio: "Portfolio",
      testimonials: "Testimonials",
      contact: "Contact",
    },
    header: {
      hello: "Welcome, I'm",
      name: "Rafat Hanna",
      role: "Front-End Developer",
      cta_cv: "Download CV",
      cta_talk: "Let's Talk",
      scroll: "Scroll Down",
    },
    about: {
      title: "About Me",
      subtitle: "Get To Know",
      experience: "Experience",
      exp_sub: "1+ years working",
      clients: "Clients",
      clients_sub: "200+ worldwide",
      projects: "Projects",
      projects_sub: "80+ Completed",
      description:
        "I am a Front-End Developer specializing in React.js with experience in Redux Toolkit, TypeScript, and modern web technologies. I build responsive, clean, and modern user interfaces with attention to detail. Always eager to learn new skills, contribute to projects, and grow as a developer.",
      cta: "Let's Talk",
    },
    skills: {
      title: "Skills",
      subtitle: "My technical expertise",
    },
    experience: {
      title: "Experience",
      subtitle: "My Journey",
    },
    services: {
      title: "Services",
      subtitle: "What I Offer",
      design: "Web Design",
      design_desc:
        "I create modern, responsive, and visually appealing UI designs focused on user experience, accessibility, and clean layout structure.",
      perf: "Fast Performance",
      perf_desc:
        "I build highly optimized web interfaces with fast loading times, smooth interactions, and best performance practices.",
      clean: "Clean Code",
      clean_desc:
        "I write clean, maintainable, and scalable code following industry standards, reusable components, and efficient architecture.",
    },
    portfolio: {
      title: "Portfolio",
      subtitle: "My Recent Work",
      github: "Github",
      demo: "Live Demo",
    },
    testimonials: {
      title: "Testimonials",
      subtitle: "Voice of Clients",
      data: [
        {
          name: "Ahmed Mohamed",
          review:
            "Rafat is an exceptional developer. His attention to detail and ability to turn complex requirements into beautiful, functional interfaces is truly impressive.",
        },
        {
          name: "Samy Fawzy",
          review:
            "Working with Rafat was a pleasure. He is fast, reliable, and always delivers high-quality code. Highly recommended for any frontend project!",
        },
        {
          name: "John Doe",
          review:
            "The futuristic design Rafat implemented for our platform completely changed our user engagement. Excellent work and a great eye for design.",
        },
      ],
    },
    contact: {
      title: "Contact Me",
      subtitle: "Get In Touch",
      email: "Email",
      messenger: "Messenger",
      whatsapp: "WhatsApp",
      send_msg: "Send Message",
      form: {
        name: "Your Full Name",
        email: "Your Email",
        msg: "Your Message",
        submit: "Send Message",
        sending: "Processing...",
        success: "Message sent successfully! 🚀",
        error: "Sending failed. ",
      },
    },
    footer: {
      rights: "All rights reserved.",
    },
  },
  ar: {
    nav: {
      home: "الرئيسية",
      about: "عني",
      experience: "الخبرة",
      services: "الخدمات",
      portfolio: "المعرض",
      testimonials: "قالوا عني",
      contact: "اتصل بي",
    },
    header: {
      hello: "أهلاً، أنا",
      name: "رأفت حنا",
      role: "مطور واجهات أمامية",
      cta_cv: "تحميل السيرة الذاتية",
      cta_talk: "دعنا نتحدث",
      scroll: "اكتشف المزيد",
    },
    about: {
      title: "عني",
      subtitle: "تعرف عليّ",
      experience: "الخبرة",
      exp_sub: "+1 سنة عمل",
      clients: "العملاء",
      clients_sub: "+200 حول العالم",
      projects: "المشاريع",
      projects_sub: "+80 مشروع مكتمل",
      description:
        "أنا مطور واجهات أمامية متخصص في React.js مع خبرة في Redux Toolkit و TypeScript والتقنيات الحديثة. أقوم ببناء واجهات مستخدم متجاوبة ونظيفة وعصرية مع الاهتمام بأدق التفاصيل. دائماً ما أسعى لتعلم مهارات جديدة والمساهمة في المشاريع والنمو كمطور.",
      cta: "دعنا نتحدث",
    },
    skills: {
      title: "المهارات",
      subtitle: "خبرتي التقنية",
    },
    experience: {
      title: "الخبرة",
      subtitle: "رحلتي",
    },
    services: {
      title: "الخدمات",
      subtitle: "ماذا أقدم",
      design: "تصميم المواقع",
      design_desc:
        "أقوم بإنشاء تصميمات واجهة مستخدم حديثة ومتجاوبة وجذابة بصرياً تركز على تجربة المستخدم وسهولة الوصول.",
      perf: "أداء سريع",
      perf_desc:
        "أقوم ببناء واجهات ويب محسنة للغاية مع أوقات تحميل سريعة وتفاعلات سلسة وأفضل ممارسات الأداء.",
      clean: "كود نظيف",
      clean_desc:
        "أنا أكتب كوداً نظيفاً وقابلاً للصيانة وللتوسع باتباع معايير الصناعة والمكونات القابلة لإعادة الاستخدام.",
    },
    portfolio: {
      title: "المعرض",
      subtitle: "أعمالي الأخيرة",
      github: "جيت هاب",
      demo: "عرض مباشر",
    },
    testimonials: {
      title: "قالوا عني",
      subtitle: "آراء العملاء",
      data: [
        {
          name: "أحمد محمد",
          review:
            "رأفت مطور استثنائي. اهتمامه بالتفاصيل وقدرته على تحويل المتطلبات المعقدة إلى واجهات جميلة ووظيفية أمر مثير للإعجاب حقاً.",
        },
        {
          name: "سامي فوزي",
          review:
            "العمل مع رأفت كان متعة. إنه سريع وموثوق ويقدم دائماً كوداً عالي الجودة. أوصي به بشدة لأي مشروع واجهة أمامية!",
        },
        {
          name: "جون دو",
          review:
            "التصميم المستقبلي الذي نفذه رأفت لمنصتنا غير تماماً من تفاعل مستخدمينا. عمل ممتاز ونظرة رائعة للتصميم.",
        },
      ],
    },
    contact: {
      title: "اتصل بي",
      subtitle: "تواصل معي",
      email: "البريد",
      messenger: "ماسينجر",
      whatsapp: "واتساب",
      send_msg: "أرسل رسالة",
      form: {
        name: "الاسم بالكامل",
        email: "بريدك الإلكتروني",
        msg: "رسالتك",
        submit: "إرسال الرسالة",
        sending: "جاري الإرسال...",
        success: "تم إرسال الرسالة بنجاح! 🚀",
        error: "فشل الإرسال. ",
      },
    },
    footer: {
      rights: "جميع الحقوق محفوظة.",
    },
  },
};
